// extracted by mini-css-extract-plugin
export var column = "styles-module--column--UiK9l";
export var container = "styles-module--container---uZmC";
export var icon = "styles-module--icon--51Q3K";
export var temperature = "styles-module--temperature--8p1bU";